import { CalendarToday, Functions } from '@mui/icons-material'
import { Box, TableCell, TableFooter, TableRow, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import { Dayjs } from 'dayjs'
import { useTranslation } from 'react-i18next'
import { getDaysOfTheMonth } from '../../../store/utils/worklogUtils'

type VacationTableFooterProps = {
  selectedDate: Dayjs
  totalVacationCount: number
  calculateVacationCount: (date: string) => number
}

const VacationTableFooter = ({
  selectedDate,
  totalVacationCount,
  calculateVacationCount,
}: VacationTableFooterProps) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const isDownXsMid = useMediaQuery(theme.breakpoints.down('xsMid'))
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <TableFooter>
      <TableRow
        sx={{
          position: 'sticky',
          bottom: 0,
          zIndex: 10,
          backgroundColor: 'background.elevation1',
          height: '2vh',
        }}
      >
        <TableCell
          sx={{
            borderTop: '1px solid',
            borderTopColor: 'background.elevation8',
            position: 'sticky',
            left: 0,
            zIndex: 12,
            pl: 1.5,
            backgroundColor: 'background.elevation1',
          }}
        >
          {isDownXsMid ? (
            <Tooltip title={`${t('page.vacationView.sum')} / ${t('page.vacationView.day')}`} arrow>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'end' }}>
                <Functions />
                <CalendarToday sx={{ fontSize: '13px' }} />
              </Box>
            </Tooltip>
          ) : (
            <Typography component="h3" variant="h6">
              {t('page.vacationView.sum')} / {t('page.vacationView.day')}
            </Typography>
          )}
        </TableCell>
        {getDaysOfTheMonth(selectedDate).map(day => (
          <TableCell
            key={day.id}
            sx={{
              width: `calc((100% - 150px) / ${getDaysOfTheMonth(selectedDate).length})`,
              position: 'sticky',
              bottom: 0,
              textAlign: 'center',
              zIndex: 10,
              borderTop: '1px solid',
              borderTopColor: 'background.elevation8',
              backgroundColor: 'background.elevation1',
            }}
          >
            <Typography variant="body1">{calculateVacationCount(day.date.format('YYYY-MM-DD')) || '-'}</Typography>
          </TableCell>
        ))}
      </TableRow>

      {!isDownSm && (
        <TableRow
          sx={{
            position: 'sticky',
            bottom: 0,
            zIndex: 9,
            backgroundColor: 'background.elevation1',
            height: '2vh',
          }}
        >
          <TableCell
            sx={{
              borderBottom: 0,
              position: 'sticky',
              left: 0,
              zIndex: 12,
              pl: 1.5,
              backgroundColor: 'background.elevation1',
            }}
          >
            {isDownXsMid ? (
              <Tooltip title={t('page.vacationView.sum')} arrow>
                <Functions />
              </Tooltip>
            ) : (
              <Typography component="h3" variant="h6">
                {t('page.vacationView.sum')}
              </Typography>
            )}
          </TableCell>
          <TableCell
            colSpan={getDaysOfTheMonth(selectedDate).length}
            sx={{
              width: `calc((100% - 150px) / ${getDaysOfTheMonth(selectedDate).length})`,
              position: 'sticky',
              bottom: 0,
              textAlign: 'center',
              zIndex: 9,
              borderBottom: 0,
              backgroundColor: 'background.elevation1',
            }}
          >
            <Typography variant="body1">
              {totalVacationCount + ' '}
              <span style={{ color: '#999999' }}>{t('page.vacationView.days')}</span>
            </Typography>
          </TableCell>
        </TableRow>
      )}
    </TableFooter>
  )
}

export default VacationTableFooter
